import React from "react";
import { Row } from "components/shared/layout";
import Input from "components/input";
import styled from "styled-components";
import TextArea from "components/textarea";
import Select from "components/select";

const QuestionGroup = styled(Row)`
  margin-bottom: 50px;
`;

const FieldWrapper = styled(Row)`
  padding: 10px;
`;

const SocialMedia = () => {
  return (
    <div>
      <Row>
        <FieldWrapper xs={12}>
          <TextArea
            style={{ minHeight: 200 }}
            name="location"
            placeholder="Location Address"
          />
        </FieldWrapper>

        <FieldWrapper xs={12}>
          <Input name="contact_number" placeholder="Contact Number" />
        </FieldWrapper>
        <QuestionGroup xs={12}>
          <FieldWrapper xs={12} md={4}>
            <Select
              name="has_facebook"
              placeholder={"Do you have a Facebook Account?"}
              options={[
                {
                  label: 'Yes',
                  value: 'yes'
                },
                {
                  label: 'No',
                  value: 'no'
                }
              ]}
            />
          </FieldWrapper>
        </QuestionGroup>
        <QuestionGroup xs={12}>
          <FieldWrapper xs={12} md={4}>
            <Select
              name="has_twitter"
              placeholder={"Do you have a Twitter?"}
              options={[
                {
                  label: 'Yes',
                  value: 'yes'
                },
                {
                  label: 'No',
                  value: 'no'
                }
              ]}
            />
          </FieldWrapper>
        </QuestionGroup>
        <QuestionGroup xs={12}>
          <FieldWrapper xs={12} md={4}>
            <Select
              name="has_instagram"
              placeholder={"Do you have an Instagram?"}
              options={[
                {
                  label: 'Yes',
                  value: 'yes'
                },
                {
                  label: 'No',
                  value: 'no'
                }
              ]}
            />
          </FieldWrapper>
        </QuestionGroup>
        <QuestionGroup xs={12}>
          <FieldWrapper xs={12} md={4}>
            <Select
              name="has_linkedin"
              placeholder={"Do you have a LinkedIn account?"}
              options={[
                {
                  label: 'Yes',
                  value: 'yes'
                },
                {
                  label: 'No',
                  value: 'no'
                }
              ]}
            />
          </FieldWrapper>
        </QuestionGroup>
        <QuestionGroup xs={12}>
          <FieldWrapper xs={12} md={4}>
            <Select
              name="has_whatsapp"
              placeholder={"Do you have a WhatsApp?"}
              options={[
                {
                  label: 'Yes',
                  value: 'yes'
                },
                {
                  label: 'No',
                  value: 'no'
                }
              ]}
            />
          </FieldWrapper>
        </QuestionGroup>
        {/* <FieldWrapper xs={12}>
          <Input name="facebook_url" placeholder="Facebook Link" />
        </FieldWrapper>
        <FieldWrapper xs={12}>
          <Input name="twitter_url" placeholder="Twitter Link" />
        </FieldWrapper>
        <FieldWrapper xs={12}>
          <Input name="instagram_url" placeholder="Instagram Link" />
        </FieldWrapper>
        <FieldWrapper xs={12}>
          <Input name="linkedin_url" placeholder="LinkedIn Link" />
        </FieldWrapper>
        <FieldWrapper xs={12}>
          <Input name="contact_phone_number" placeholder="Contact Phone Number" />
        </FieldWrapper>
        <FieldWrapper xs={12}>
          <Input name="whatsapp_number" placeholder="WhatsApp Number" />
        </FieldWrapper> */}
      </Row>
    </div>
  );
};
export default SocialMedia;
